import { render, staticRenderFns } from "./ExistTag.vue?vue&type=template&id=4a96a93a"
import script from "./ExistTag.vue?vue&type=script&lang=js"
export * from "./ExistTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a96a93a')) {
      api.createRecord('4a96a93a', component.options)
    } else {
      api.reload('4a96a93a', component.options)
    }
    module.hot.accept("./ExistTag.vue?vue&type=template&id=4a96a93a", function () {
      api.rerender('4a96a93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/Modals/ExistTag.vue"
export default component.exports